var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1334 10.1611C17.4925 9.80211 17.9795 9.60049 18.4873 9.60059C18.995 9.60068 19.4819 9.80248 19.8409 10.1616C20.1999 10.5207 20.4015 11.0077 20.4014 11.5154C20.4013 12.0232 20.1995 12.5101 19.8404 12.8691L19.1074 13.6011L16.3984 10.8951L17.1324 10.1611H17.1334ZM15.6934 11.6021L9.73734 17.5561C9.55655 17.737 9.4203 17.9575 9.33934 18.2001L8.42533 20.9432C8.39614 21.0312 8.39199 21.1256 8.41336 21.2158C8.43473 21.306 8.48078 21.3886 8.54635 21.4541C8.61192 21.5197 8.69444 21.5658 8.78468 21.5871C8.87492 21.6085 8.96932 21.6044 9.05734 21.5752L11.8004 20.6611C12.0434 20.5811 12.2634 20.4441 12.4444 20.2631L18.4004 14.3091L15.6924 11.6021H15.6934Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.8715b9963743c876e4620b2baa5744d9.svg";
export { ForwardRef as ReactComponent };